import { Button, ScalableImage, Typography, useDevice, useWindowSize } from "design_system/src";
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

export interface ItemsProps {
  title: string;
  text: React.ReactNode;
  className: string;
  button?: {
    onClick: any;
    text: string;
  };
  imageUrl: string;
  desktopImageUrl: string;
  imageAlt: string;
}


const Benefits: React.FC = () => {
  const { isMobile: isMobileDevice, isLoading } = useDevice();
  const { width } = useWindowSize();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [items, setItems] = useState<ItemsProps[]>();

  useEffect(() => {
    if (!isLoading) {
      setIsMobile(isMobileDevice);
    }
  }, [isMobileDevice, isLoading]);

  const onReferralClick = () => {
    ReactGA.event("CTA_Home_go_to_referral_screen", {
      category: "Home",
      label: "click in CTA to go to referral screen",
    });
  };

  useEffect(() => {
    setItems([
      {
        title: "Refiere y gana",
        text: <>Refiere a un amigo para que <strong>financie su moto con Ozon</strong> y ambos <strong>obtendrán beneficios.</strong></>,
        className: `h_100_per ${width < 900 ? "w_100_per p_b_md" : "w_55_per p_r_sm"}`,
        imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/refiere_y_gana_financiamiento_facil_small",
        desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/refiere_y_gana_financiamiento_facil",
        imageAlt: "Programa refiere y gana de Ozon – obtén beneficios por recomendar",
        button: {
          onClick: onReferralClick,
          text: "Quiero referir"
        }
      },
      {
        title: "¿Quieres tu segunda moto?",
        text: <><strong>Paga el 70% del crédito</strong> sin atrasos y podrás adelantar <strong>tu segunda moto</strong> con Ozon.</>,
        className: `h_100_per ${width < 900 ? "w_100_per" : "w_45_per p_l_sm"}`,
        imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/segunda_moto_financiamiento_facil_small",
        desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/segunda_moto_financiamiento_facil",
        imageAlt: "Financiamiento para segunda moto con Ozon – solicita tu crédito"
      }
    ]);
  }, [width]);

  return (
    <section className="dso_container p_y_md">
      <Typography
        scale="heading1"
        scaleMobile="heading3"
        weight="600"
        component="h2"
      >
        Aceleramos tus sueños <br className="display_none_mobile"/>con beneficios exclusivos
      </Typography>

      <div className="display_flex flex_wrap">
        {items?.map((item, i) => {
          return (
            <div className={item.className} key={`others-section-${i}`}>
              <div
                className="bg_primary_100 p_y_xxxl_desktop p_x_xxl_desktop br_md pos_relative h_100_per"
                style={{
                  // eslint-disable-next-line no-nested-ternary
                  minHeight: width >= 900 ? "350px" : !isMobile ? "200px" : "unset",
                }}
              >
                <div
                  className="w_100_per_mobile w_40_per display_flex flex_col flex_justify_evenly p_t_xxxl_mobile p_x_xxl_mobile"
                  style={{
                    position: width >= 900 ? "absolute" : "static",
                    zIndex: 1,
                  }}
                >
                  <Typography
                    weight="600"
                    scale="heading2"
                    scaleMobile="heading3"
                    className="text_primary_300 m_b_md"
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    weight="400"
                    scale="heading4"
                    scaleMobile="large"
                    className="m_b_md"
                  >
                    {item.text}
                  </Typography>
                  {item.button && (
                    <div className="w_100_per_mobile w_80_per m_t_lg">
                      <Link to="/referidos">
                        <Button onClick={item.button.onClick} className="w_100_per">
                          <Typography
                            weight="600"
                            scale="medium"
                            scaleMobile="medium"
                          >
                            {item.button.text}
                          </Typography>
                        </Button>
                      </Link>
                    </div>
                  )}
                </div>

                {isMobile !== undefined && (
                  <div
                    className="h_100_per"
                    style={{
                      position: !isMobile ? "absolute" : "static",
                      top: 0,
                      right: 0,
                      zIndex: 0,
                    }}
                  >
                    <ScalableImage
                      className="img_contain display_block"
                      src={isMobile ? item.imageUrl : item.desktopImageUrl}
                      alt={item.imageAlt}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Benefits;
